import React, { ReactNode } from 'react';
import styled from 'styled-components';

import EventOption from '../../components/EventOption';
import CreateEventPromo from '../../components/promo/CreateEventPromo';
import { DeviceQueries } from 'Common/src/components/styled';
import CreateEventRow from './CreateEventRow';
import { IUEvent } from '../../lib/event';

const EventRow = ({ event, onClick, showAttendees, showCreate, showPlus }: {
  event?: IUEvent,
  onClick: (event: IUEvent) => void,
  showAttendees: boolean,
  showCreate?: boolean,
  showPlus?: boolean
}) => {
  const handleRowClick = () => {
    if (event !== undefined) {
      onClick(event);
    }
  };

  let content: ReactNode;
  if (event === undefined && showPlus) {
    content = <CreateEventRow/>;
  } else if (event === undefined && showCreate) {
    content = <CreateEventPromo/>;
  } else if (event === undefined) {
    content = <EventOption
      event={event}
      showAttendees={showAttendees}
      isCreatePrompt={false}
    />;
  } else {
    content = <EventOption
      event={event}
      showAttendees={showAttendees}
      isCreatePrompt={false}
    />;
  }

  return <EventRowInner onClick={handleRowClick} $loading={!showCreate && event === undefined}>
    {content}
  </EventRowInner>;
};

export default EventRow;

const EventRowInner = styled.div<{$loading: boolean}>`
  width: 400px;
  border-radius: 8px;
  border: ${({ $loading }) => $loading ? '1px dashed #c6c6c6' : '1px solid #fff'};
  background-color: rgba(0,0,0,0.2);
  cursor: pointer;

  @media (${DeviceQueries.mobile}) {
    max-width: 100%;
    margin: 0 0 20px;
  }
`;
